import { Box, Icon, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  dettaglioIsBlock,
  dettaglioIsSlab,
  dettaglioIsTiles,
} from "../../../lib/functions";
import { ICellPublishedParams, ICellTipoLottoParams } from "./interfaces";

const i18_PATH = "prodotto.share.tableCells.";

export function CellTipoLotto({ dettaglio }: ICellTipoLottoParams) {
  const color = dettaglio.disponibilita?.coloreWeb ?? "inherit";
  const tooltipSuffix = dettaglio.disponibilita?.nome
    ? ` - ${dettaglio.disponibilita.nome}`
    : "";
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {dettaglioIsBlock(dettaglio) && (
        <Tooltip title={`Blocco${tooltipSuffix}`}>
          <Icon
            className="fa-light fa-cube"
            sx={{ overflow: "visible", color }}
          />
        </Tooltip>
      )}
      {dettaglioIsSlab(dettaglio) && (
        <Tooltip title={`Lastre${tooltipSuffix}`}>
          <Icon
            className="fa-light fa-layer-group"
            sx={{ overflow: "visible", color }}
          />
        </Tooltip>
      )}
      {dettaglioIsTiles(dettaglio) && (
        <Tooltip title={`Marmette${tooltipSuffix}`}>
          <Icon
            className="fa-light fa-bring-forward"
            sx={{ overflow: "visible", color }}
          />
        </Tooltip>
      )}
    </Box>
  );
}

export function CellWebPublished({ dettaglio }: ICellPublishedParams) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {!!dettaglio.lotto?.pubblicatoSuWeb && (
        <Tooltip title={t(`${i18_PATH}Pubblicato`)}>
          <Icon
            color="success"
            className="fa-solid fa-globe-pointer"
            sx={{ overflow: "visible" }}
          />
        </Tooltip>
      )}
    </Box>
  );
}
